var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-img',{ref:"image",staticClass:"img",class:{ full: _vm.animate },attrs:{"alt":"Mobishaala logo","contain":"","src":require("@/assets/img/text_logo.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }